// Fix Q (2026-10-13): textos, formatos y reglas de la app del chofer. Toda la app del chofer está en inglés.
// Las claves de etapa, tipo de documento y motivo son las del servidor (backend/etapas.py); solo cambia lo que se ve.
import { siglaZona } from "@/lib/format";
import { t, getIdioma } from "@/lib/i18n";
const TZ = "America/Chicago";
const ZONAS_OK = ["America/Chicago", "America/New_York", "America/Denver", "America/Los_Angeles"];
const zonaOk = (z) => (ZONAS_OK.includes(z) ? z : TZ);
export const TIPO_EN = { get importacion() { return t("IMPORT"); }, get exportacion() { return t("EXPORT"); } };
export const MOTIVO_LIBERAR_EN = { get problema_mecanico() { return t("Mechanical problem"); }, get fuera_de_horario() { return t("Out of hours"); }, get cliente_cerrado() { return t("Customer closed"); }, get otro() { return t("Other"); } };
export const MOTIVO_PENDIENTE_EN = { get celular_roto() { return t("Broken phone"); }, get sin_bateria() { return t("Dead battery"); }, get otro() { return t("Other"); } };
export const INCIDENTE_TIPO_EN = { get llanta() { return t("Tire"); }, get falla_mecanica() { return t("Mechanical failure"); }, get accidente() { return t("Accident"); }, get otro() { return t("Other"); } };
export const INSUMO_ESTADO_EN = {
  get pendiente() { return t("Pending"); }, get entregado() { return t("Delivered"); }, get pendiente_aprobacion() { return t("Waiting for approval"); },
  get aprobado() { return t("Approved"); }, get rechazado() { return t("Rejected"); }, get registrado() { return t("Recorded"); },
};
export const TIPO_DESCARGA_EN = { get live_unload() { return t("Live unload"); }, get drop() { return t("Drop"); } };
// ---------- Fechas y horas en inglés, en la zona horaria de la etapa ----------
const loc = () => (getIdioma() === "es" ? "es" : "en-US");
const mes = (dt, tz) => new Intl.DateTimeFormat(loc(), { month: "short", day: "numeric", timeZone: tz }).format(dt).replace(/\./g, "");
// "2026-10-13" → "Oct 13"
export function diaEn(ymd) {
  if (!ymd) return "—";
  const [y, m, d] = ymd.split("-").map(Number);
  return mes(new Date(Date.UTC(y, m - 1, d, 12)), "UTC");
}
// "07:00" → "7:00 AM"
export function horaEn(hhmm) {
  if (!hhmm) return "—";
  const [h, m] = hhmm.split(":").map(Number);
  return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${h >= 12 ? "PM" : "AM"}`;
}
// instante UTC → "Oct 13 · 8:00 AM CT"
export function fechaHoraEn(iso, zona) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "—";
  const tz = zonaOk(zona);
  const hora = new Intl.DateTimeFormat("en-US", { hour: "numeric", minute: "2-digit", hour12: true, timeZone: tz }).format(d);
  return `${mes(d, tz)} · ${hora} ${siglaZona(tz)}`;
}
// hora de pared (fecha + HH:MM) → "Oct 13 · 10:00 AM CT"
export function paredEn(ymd, hhmm, zona) {
  if (!ymd) return "—";
  return `${diaEn(ymd)}${hhmm ? ` · ${horaEn(hhmm)}` : ""} ${siglaZona(zonaOk(zona))}`;
}
// "Mon-Fri · 7:00 AM - 4:00 PM CT" (o "7:00 AM - 6:00 PM CT"); vacío si la etapa no tiene horario
export function horarioEn(e) {
  const z = siglaZona(zonaOk(e.zona_horaria));
  let h = "";
  if (e.hora_desde && e.hora_hasta) h = `${horaEn(e.hora_desde)} - ${horaEn(e.hora_hasta)} ${z}`;
  else if (e.hora_desde) h = t("From {hora}", { hora: `${horaEn(e.hora_desde)} ${z}` });
  else if (e.hora_hasta) h = t("Until {hora}", { hora: `${horaEn(e.hora_hasta)} ${z}` });
  return [e.dias, h].filter(Boolean).join(" · ");
}
// Cita del Delivery = su ventana Desde–Hasta: "Oct 13 · 9:00 AM - 4:00 PM CT" (o una sola hora si Desde = Hasta)
export function citaEn(e) {
  if (!e.fecha) return horarioEn(e);
  let h = "";
  if (e.hora_desde && e.hora_hasta) h = e.hora_desde === e.hora_hasta ? horaEn(e.hora_desde) : `${horaEn(e.hora_desde)} - ${horaEn(e.hora_hasta)}`;
  else if (e.hora_desde) h = t("From {hora}", { hora: horaEn(e.hora_desde) });
  else if (e.hora_hasta) h = t("Until {hora}", { hora: horaEn(e.hora_hasta) });
  return [e.dias, `${diaEn(e.fecha)}${h ? ` · ${h}` : ""} ${siglaZona(zonaOk(e.zona_horaria))}`].filter(Boolean).join(" · ");
}
// "Tuesday, Oct 13" (hoy, en Chicago)
export function hoyEn() {
  return new Intl.DateTimeFormat(loc(), { weekday: "long", month: "short", day: "numeric", timeZone: TZ }).format(new Date());
}
export function hoyYmd() {
  return new Intl.DateTimeFormat("en-CA", { timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date());
}
// ---------- Etapas ----------
export const activas = (c) => (c?.etapas || []).filter((e) => e.activa).sort((a, b) => a.orden - b.orden);
export const etapaActual = (c) => activas(c).find((e) => !e.salida_at) || null;
export const misEtapas = (c, uid) => activas(c).filter((e) => e.chofer_id === uid);
export const numeroEtapa = (c, clave, uid) => misEtapas(c, uid).findIndex((e) => e.clave === clave) + 1;
export const normContenedor = (s) => (s || "").replace(/[\s-]/g, "").toUpperCase();
// Documento que se puede adjuntar en cada etapa (tipo del servidor y nombre que ve el chofer).
export const DOC_ETAPA = {
  pick_chassis: { tipo: "pickup_receipt", get nombre() { return t("Pickup receipt"); } },
  rail_pickup: { tipo: "rail_receipt", get nombre() { return t("Rail pickup receipt"); } },
  empty_pickup: { tipo: "container_photo", get nombre() { return t("Container photo"); } },
  pickup_location: { tipo: "otro", get nombre() { return t("Other document"); } },
  return_loaded: { tipo: "otro", get nombre() { return t("Other document"); } },
  yard_stop: { tipo: "otro", get nombre() { return t("Other document"); } },
  delivery: { tipo: "signed_pod", get nombre() { return t("Signed DO / POD"); } },
  return_empty: { tipo: "empty_j1", get nombre() { return t("Empty return J1"); } },
  return_chassis: { tipo: "chassis_j1", get nombre() { return t("Chassis return J1"); } },
};
export function docDeEtapa(c, clave) {
  const base = DOC_ETAPA[clave];
  const d = (c.docs || []).find((x) => x.etapa === clave);
  return { ...base, requerido: !!d?.requerido, recibido: (d?.total || 0) > 0 };
}
export const CONFIRMAR_EN = {
  get pick_chassis() { return t("Confirm pickup and departure"); },
  get rail_pickup() { return t("Confirm pickup and departure"); },
  get empty_pickup() { return t("Confirm pickup and departure"); },
  get pickup_location() { return t("Confirm loading and departure"); },
  get return_loaded() { return t("Confirm loaded return and departure"); },
  get yard_stop() { return t("Confirm yard stop and departure"); },
  get delivery() { return t("Confirm delivery and departure"); },
  get return_empty() { return t("Confirm empty return and departure"); },
  get return_chassis() { return t("Finish Trip"); },
};
// Archivos que subió ESTE chofer (cuenta para «Files (N)»; el Delivery Order de la oficina no cuenta).
export const misArchivos = (c, uid) => (c?.archivos || []).filter((a) => a.origen === "chofer" && a.chofer_id === uid);
// Dónde está el chofer respecto de la carga: lo que se muestra en la lista y qué pantalla se abre.
export function estadoChofer(c, uid) {
  if (c.estado === "cancelada") return { k: "cancelled", label: t("Cancelled") };
  const act = etapaActual(c);
  if (!act) return { k: "completed", label: t("Completed") };
  const pendientes = activas(c).filter((e) => e.chofer_id === uid && !e.salida_at);
  if (pendientes.length === 0) return { k: "my_part_done", label: t("Your steps are done") };
  if (!c.es_mi_turno) return { k: "waiting", label: t("Waiting for previous steps") };
  if (!c.viaje_inicio_at) return { k: "ready", label: t("Ready to start") };
  return { k: "in_progress", label: t("Step {v0} of {length}", { v0: numeroEtapa(c, act.clave, uid), length: misEtapas(c, uid).length }) };
}
// Documentos obligatorios que le faltan a ESTE chofer: de etapas suyas que ya cerró (los de una etapa en curso todavía no cuentan).
export function docsPendientes(c, uid) {
  return (c?.docs_faltantes || []).filter((d) => {
    const e = (c.etapas || []).find((x) => x.clave === d.etapa);
    return !!e && e.chofer_id === uid && !!e.salida_at;
  });
}
// Lo próximo que tiene que tocar el chofer (texto del botón de la lista).
export function proximoPasoChofer(c, uid) {
  const est = estadoChofer(c, uid);
  const act = etapaActual(c);
  if (est.k === "completed" || est.k === "my_part_done") return t("View trip");
  if (est.k === "cancelled") return t("View load");
  if (est.k === "waiting") return t("Waiting for previous steps");
  if (est.k === "ready") return t("Start Trip");
  return act.llegada_at ? CONFIRMAR_EN[act.clave] : t("Record arrival · {nombre}", { nombre: t(act.nombre) });
}
